(function () {
  function initCollectionForms() {
    document.querySelectorAll('[data-exode-collection-form]').forEach((form) => {
      if (form.dataset.exodeBound === 'true') return;
      form.dataset.exodeBound = 'true';

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[data-exode-collection-atc]');
        if (!btn || btn.disabled) return;

        const span = btn.querySelector('span') || btn;
        const original = span.textContent;
        btn.disabled = true;
        span.textContent = btn.dataset.labelAdding || 'Ajout…';

        const root = window.Shopify?.routes?.root || '/';

        try {
          const res = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form) });
          if (!res.ok) throw new Error('add failed');

          span.textContent = btn.dataset.labelAdded || 'Ajouté ✓';

          if (window.ExodeCart) {
            await window.ExodeCart.refresh();
            window.ExodeCart.open();
          }

          setTimeout(() => {
            span.textContent = original;
            btn.disabled = false;
          }, 2000);
        } catch {
          span.textContent = 'Erreur';
          setTimeout(() => {
            span.textContent = original;
            btn.disabled = false;
          }, 2000);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionForms);
  } else {
    initCollectionForms();
  }
})();
